var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 94,
    viewBox: "0 0 93 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6296 44.1802C77.0554 63.6086 67.3873 81.5528 52.0354 84.2598C36.6835 86.9667 21.4611 73.4113 18.0354 53.9829C14.6096 34.5545 24.2777 16.6103 39.6296 13.9033C54.9816 11.1963 70.2039 24.7518 73.6296 44.1802Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3091 46.0063C89.3043 47.8582 87.7989 49.3555 85.947 49.3506L80.7599 49.3369L80.7849 58.8034C80.7898 60.6623 79.2816 62.1704 77.4227 62.1655L62.4451 62.1259C60.6001 62.121 59.1056 60.6265 59.1007 58.7815L59.0757 49.2797L47.9277 49.2503C47.0245 54.807 43.8012 59.765 38.994 62.8294L38.2612 63.2746C32.0488 66.8692 24.3658 66.8546 18.1879 63.2263C11.9793 59.6123 8.16552 52.9585 8.19497 45.7511C8.35594 34.8382 17.2388 26.1092 28.1536 26.1379C37.9371 26.1637 46.1149 33.2182 47.8466 42.5436L62.3702 42.582C62.3897 42.5817 62.4094 42.5816 62.429 42.5816L77.4065 42.6211C77.4252 42.6211 77.4438 42.6213 77.4624 42.6217L85.9647 42.6442C87.8167 42.6491 89.314 44.1543 89.3091 46.0063ZM41.4787 45.9234L41.4754 45.9555C41.3301 38.6997 35.3922 32.8636 28.1359 32.8444C20.8933 32.8253 15.0076 38.6091 14.9011 45.8142C14.8817 50.5868 17.4235 55.0213 21.573 57.4368C25.6758 59.8464 30.7784 59.856 34.9025 57.4697C38.9996 55.0993 41.5063 50.7151 41.4795 45.9687C41.4791 45.9536 41.4789 45.9385 41.4787 45.9234ZM65.7808 49.2974L65.7974 55.4248L74.0726 55.4485L74.056 49.3192L65.7808 49.2974Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.92df21ea7b7ff2181ec932f349f1b932.svg";
export { ForwardRef as ReactComponent };